import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ConsumablesMaster',
  //   description: 'description of ConsumablesMaster',
  //   url: '/consumables-master',
  // },
];

export default help;
